import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LanguageService } from '../shared/service/language.service';

@Injectable({
  providedIn: 'root'
})
export class RouterLanguageGaurdGuard  {

  constructor(private readonly router: Router, private readonly languageService: LanguageService) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const languageId = this.languageService.getLanguage();
      const originalUrl = state.url;      
      if(originalUrl.startsWith('/events') || originalUrl.startsWith('/home') || originalUrl.startsWith('/locations') || originalUrl.startsWith('/profile')) {
        const modifiedUrl = `/${languageId}${originalUrl}`;
        this.router.navigate([modifiedUrl]);
      } 
      return true;
  } 
}
